import React, { useEffect } from "react";
import { any } from "prop-types";

import { PopupButton } from "@typeform/embed-react";

import CoverPorfolio from "../../components/cover-portfolio";
import PeopleOfMasamune from "../../components/people-of-masamune";
import { DetailsProject } from "../../components/portfolio-components";

import { FullWidthVideo } from "../../ui-components/videos";
import {
	LargeText,
	MediumHeading,
	MediumTitle,
	SmallTitle,
} from "../../ui-components/texts";
import {
	Column,
	Container,
	ContainerBlock,
} from "../../ui-components/columns/components";

// images
import imageCover from "../../media/images/portfolio-images/correre-naturale/image-cover.jpg";
import image1 from "../../media/images/portfolio-images/correre-naturale/image-1.jpg";
import image2 from "../../media/images/portfolio-images/correre-naturale/image-2.jpg";
import testImage from "../../media/test-image-square.jpg";
import { useTranslate } from "../../contexts/translate";

const CorrereNaturale = ({
	setNextPageHref = () => { },
	setNextPageName = () => { },
}) => {
	useEffect(() => {
		setNextPageHref("/projects/ofit");
		setNextPageName("Ofit");
		document.title = 'Correre Naturale - Cutting Edge Digital Creative Studio'
	}, []);

	const { translations } = useTranslate();

	const peoples = [
		{
			fullname: "Andrea Carollo",
			image: require("../../media/team-images/Andrea Carollo.jpg").default,
			role: translations === null ? "" : translations.about.peoples[4].role,
			//description:
				//translations === null ? "" : translations.about.peoples[4].description,
			description: "",
		},
		{
			fullname: "Magda Sgarella",
			image: require("../../media/team-images/Magda Sgarella.jpg").default,
			role: translations === null ? "" : translations.about.peoples[5].role,
			description:
				translations === null ? "" : translations.about.peoples[5].description,
		}
	];

	return (
		<div className="project-page project-page-us-lecce">
			<CoverPorfolio
				background="#fff"
				title="Correre Naturale"
				text={translations && translations.correrenaturale.intro}
				image={imageCover}
			/>

			<DetailsProject
				client={"Correre Naturale"}
				services={["Digital Strategy", "Social Advertising"]}
				timeframe={"2021 - Today"}
				introduction={
					<>
						<LargeText>
							{translations && translations.correrenaturale.descriptions[0]}
						</LargeText>
						<LargeText>
							{translations && translations.correrenaturale.descriptions[1]}
						</LargeText>
						<LargeText>
							{translations && translations.correrenaturale.descriptions[2]}
						</LargeText>
					</>
				}
			/>

			<section
				className="theme-light mid-padding"
				style={{ background: "#F0FFC9" }}
			>
				<Container>
					<div className="wrapper fluid">
						<Column className="d-flex flex-column w-50">
							<SmallTitle className="mb-5">
								{translations && translations.correrenaturale.sections[0].title}
							</SmallTitle>

							<img src={image2} className="mt-auto" alt="image 1" />
						</Column>
						<Column className="d-flex flex-column w-50">
							<LargeText>
								{translations && translations.correrenaturale.sections[0].text}
							</LargeText>

							<img src={image1} className="mt-5" alt="image 2" />
						</Column>
					</div>
				</Container>
			</section>

			<section
				className="theme-light mid-padding"
				style={{ background: "#fff" }}
			>
				<Container>
					<div className="wrapper fluid">
						<Column className="w-100">
							<MediumHeading>
								{translations && translations.correrenaturale.sections[1].text}
							</MediumHeading>
						</Column>
					</div>
				</Container>

				<Container className="pt-50">
					<div className="wrapper fluid">
						<Column className="w-40">
							<MediumTitle>+ 1040%</MediumTitle>
							<MediumHeading>ROAS</MediumHeading>
						</Column>
						<Column className="w-40">
							<MediumTitle>1,10%</MediumTitle>
							<MediumHeading>Click-through rate</MediumHeading>
						</Column>
					</div>
				</Container>

				<Container>
					<div className="wrapper fluid">
						<Column className="w-40">
							<MediumTitle>6,60%</MediumTitle>
							<MediumHeading>Conversion Rate Webinar</MediumHeading>
						</Column>
						<Column className="w-40">
							<MediumTitle>2,45%</MediumTitle>
							<MediumHeading>Conversion Rate Running School</MediumHeading>
						</Column>
					</div>
				</Container>
			</section>

			<PeopleOfMasamune peoples={peoples} />
					<div className="cta-single-project">
				<div className="cta-single-project-inner">
					<p>{translations && translations.ctasingleproject.text}</p>
					<button
						className="leadconnector-button"
						onClick={() => {
							const overlay = document.createElement("div");
							overlay.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													background-color: rgba(0, 0, 0, 0.7);
													backdrop-filter: blur(5px);
													z-index: 9998;
												`;

							const modal = document.createElement("div");
							modal.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													z-index: 9999;
												`;

							const closeBtn = document.createElement("button");
							closeBtn.innerHTML = "✕";
							closeBtn.style.cssText = `
													position: fixed;
													top: 30px;
													right: 30px;
													width: 50px;
													height: 50px;
													border: none;
													background-color: rgba(255, 255, 255, 0.2);
													color: white;
													border-radius: 50%;
													cursor: pointer;
													font-size: 28px;
													z-index: 10000;
													transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
													backdrop-filter: blur(10px);
													border: 1px solid rgba(255, 255, 255, 0.3);
													display: flex;
													align-items: center;
													justify-content: center;
												`;
							closeBtn.onmouseover = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.3)";
								closeBtn.style.transform = "scale(1.15) rotate(90deg)";
								closeBtn.style.boxShadow = "0 8px 32px rgba(0, 0, 0, 0.3)";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.5)";
							};
							closeBtn.onmouseout = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
								closeBtn.style.transform = "scale(1) rotate(0deg)";
								closeBtn.style.boxShadow = "none";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.3)";
							};
							closeBtn.onclick = () => {
								overlay.style.opacity = "0";
								modal.style.opacity = "0";
								overlay.style.transition = "opacity 0.4s ease-out";
								modal.style.transition = "opacity 0.4s ease-out";
								setTimeout(() => {
									document.body.removeChild(overlay);
									document.body.removeChild(modal);
								}, 400);
							};

							const iframe = document.createElement("iframe");
							iframe.src =
								"https://api.leadconnectorhq.com/widget/survey/fXRdOm9p3aM4iNGpHfOa?notrack=true";
							iframe.style.cssText = `
													width: 100%;
													height: 100%;
													border: none;
												`;
							iframe.allowFullscreen = true;

							modal.appendChild(iframe);
							modal.appendChild(closeBtn);
							document.body.appendChild(overlay);
							document.body.appendChild(modal);

							overlay.onclick = () => {
								document.body.removeChild(overlay);
								document.body.removeChild(modal);
							};
						}}
					>
						{translations && translations.ctasingleproject.button}
					</button>
				</div>
			</div>
		</div>
	);
};

CorrereNaturale.propTypes = {
	setNextPageHref: any,
	setNextPageName: any,
};

export default CorrereNaturale;
